import { Route, Routes } from 'react-router-dom';
import ReportAndAnalyticsPage from '../../Pages/ReportAndAnalytics/ReportAndAnalytics.Page';
import SalesByCategoryPage from '../../Pages/SalesByCategory/SalesByCategory.Page';
import SalesByCategoryStats from '../../Pages/SalesByCategoryStats/SalesByCategoryStats.Page';
import AgedInventoryPage from '../../Pages/AgedInventory/AgedInventory.Page';
import LowInventoryProductsPage from '../../Pages/LowInventoryProducts/LowInventoryProducts.Page';
import SalesByCustomCollectionPage from '../../Pages/SalesByCustomCollection/SalesByCustomCollection.Page';
import ReturnRatioPage from '../../Pages/ReturnRatio/ReturnRatio.Page';
import ProductInsightsPage from '../../Pages/ProductInsights/ProductInsights.Page';
import ProductStatsAndInsightPage from '../../Pages/ProductStatsAndInsight/ProductStatsAndInsight.Page';

function ReportAndAnalyticsRoute() {
    return (
        <Routes>
            <Route index element={<ReportAndAnalyticsPage />} />

            {/* Sales Insights */}
            <Route path="sales-by-category">
                <Route index element={<SalesByCategoryPage />} />

                <Route path=':category' element={<SalesByCategoryStats />} />
            </Route>

            <Route path='sales-by-custom-collection'>
                <Route index element={<SalesByCustomCollectionPage />} />

                <Route path=':category' element={<SalesByCategoryStats />} />
            </Route>

            <Route path="return-ratio" element={<ReturnRatioPage />} />

            {/* Product & Inventory Insights */}
            <Route path="aged-inventory" element={<AgedInventoryPage />} />

            <Route path="low-inventory-products" element={<LowInventoryProductsPage />} />

            <Route path="product-insights">
                <Route index element={<ProductInsightsPage />} />

                <Route path=":productID" element={<ProductStatsAndInsightPage />} />
            </Route>
        </Routes>
    );
}

export default ReportAndAnalyticsRoute;
